<template>
  <div v-if="homeValue">
    <PopulationAgeChart
      class="-mx-6 lg:mx-0"
      :population="homeValue.Property.JSONContext.contesto.popolazione"
    />
    <FamiliesChart
      class="-mx-6 lg:mx-0"
      :population="homeValue.Property.JSONContext.contesto.popolazione"
    />
  </div>
</template>

<script>
import FamiliesChart from '~/components/FamiliesChart.vue'
import PopulationAgeChart from '~/components/PopulationAgeChart.vue'

export default {
  components: {
    FamiliesChart,
    PopulationAgeChart,
  },
  props: {
    homeValue: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
}
</script>
